export function getInclusionToggleTooltip(value: boolean) {
  const ending = value ? 'inclusion' : 'exclusion'
  return `Toggle inclusion/exclusion logic, current mode: ${ending}`
}
